import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const monitoringBatchService = createApi({
    reducerPath: 'monitoringBatchService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['MonitoringBatch'],
    endpoints: (builder) => ({
        getAllMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.getAll}/${body.page}/${body.size}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        searchMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${body.token}`
                    },
                };
            },
        }),
        getMonitoringBatchById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadMonitoringBatch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.monitoringBatchController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllMonitoringBatchMutation,
    useSearchMonitoringBatchMutation,
    useSaveMonitoringBatchMutation,
    useUpdateMonitoringBatchMutation,
    useDeleteMonitoringBatchMutation,
    useGetMonitoringBatchByIdMutation,
    useFindAllMonitoringBatchMutation,
    useBulkUploadMonitoringBatchMutation,
} = monitoringBatchService;
